import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { I18nProvider } from "@/lib/i18n";
import { SettingsProvider } from "@/lib/settings";
import StayPage from "@/pages/StayPage";
import StaysPage from "@/pages/StaysPage";
import AdminLogin from "@/pages/AdminLogin";
import AdminPage from "@/pages/AdminPage";

function App() {
  return (
    <I18nProvider>
      <SettingsProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<StayPage />} />
          <Route path="/stays" element={<StaysPage />} />
          <Route path="/stay/:slug" element={<StayPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="*" element={<StayPage />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-center" />
      </SettingsProvider>
    </I18nProvider>
  );
}

export default App;
